export default __webpack_public_path__ + "static/media/home-bg-blob.94025019.svg";